const styles = {
  extratsMainContainer: {
    display: "flex",
    flexDirection: "column",
  },
  conatainer: {
    display: "flex",
  },
  iconButton: {
    height: "42px",
  },
};

export default styles;
